import React, { FC } from 'react'

import { cx } from '@linaria/core'

import { iconSizeCss } from 'components/block/Navigation/TabBar/TabBar.styled'

import { ManSvg } from '../svgr/ManSvg'
import { WomanSvg } from '../svgr/WomanSvg'

export const MobileAvatar: FC<{
  gender: 'M' | 'F'
  size?: number
}> = ({ gender, size = 24 }) => {
  if (gender === 'F') {
    return <WomanSvg width={size} height={size} className={cx(iconSizeCss)} />
  }

  return <ManSvg width={size} height={size} className={cx(iconSizeCss)} />
}
